import cognitoPasswordRules from "@gap/utils/auth/cognitoPasswordRules"
import { FormHandlerFieldUtils } from "reusable/mobx-store-utils/form-handlers/new/form-handler"

/**
 * This function validates a given formHandler field to check if the password is valid according to our cognitoPasswordRules
 * @param formHandlerField field in your formhandler. ex. this.formHandler.password
 * @returns 
 */
const validatePassword = (formHandlerField: FormHandlerFieldUtils | Omit<FormHandlerFieldUtils, 'resetErrors'>) => {
   'resetErrors' in formHandlerField && formHandlerField.resetErrors()
   const password = formHandlerField.getValue() as string

   let hasError = false

   Object.entries(cognitoPasswordRules).some(([_, validate]) => {
      const { errorMessage } = validate(password)
      if (errorMessage) {
         hasError = true
         formHandlerField.setError(errorMessage)
      }
   })

   return hasError
}

export default validatePassword
